export const OMDB_URL = `https://${process.env.REACT_APP_OMDB_HOST}/?apiKey=${process.env.REACT_APP_OMDB_KEY}`
